import { audioManager } from './AudioManager.js';
import { iconHtml } from '../ui/iconHtml.mjs';
import { isTouchDevice } from '../ui/isTouchDevice.js';
import { shieldFromPhaser } from '../ui/uiShield.js';

// Two round mute buttons (music + sfx) as a DOM overlay over the canvas. Mounted
// once from main.js so it persists across every Phaser scene. Big tap targets for
// a young child; state is owned by AudioManager (persisted to localStorage).
// `onSettings`: a third round button, the gear — Ustawienia (ui/SettingsModal.js). Shown only
// while someone is logged in (window.__myId), so the login screen has no settings to open.
export function mountAudioControls(parent = document.body, { onSettings = null } = {}) {
  // Phones: a tighter 44 px column tucked into the corner, so it clears the joystick below it on
  // a short landscape screen (iPhone SE: 320 px) and the scene's own buttons beside it.
  const touch = isTouchDevice();
  const size = touch ? 44 : 56, edge = touch ? 6 : 12;
  const bar = document.createElement('div');
  bar.style.cssText = [
    'position:fixed', `top:${edge}px`, `left:${edge}px`, 'z-index:1000',
    'display:flex', 'flex-direction:column', `gap:${touch ? 8 : 10}px`,
  ].join(';');

  const makeBtn = (onLabel, offLabel, title, isMuted, onToggle) => {
    const btn = document.createElement('button');
    btn.title = title;
    btn.setAttribute('aria-label', title);
    btn.style.cssText = [
      `width:${size}px`, `height:${size}px`, 'border-radius:50%', 'border:none',
      `font-size:${touch ? 21 : 26}px`, 'cursor:pointer', 'background:#000000cc', 'color:#fff',
      `line-height:${size}px`, 'padding:0', 'box-shadow:0 2px 6px #0006', 'user-select:none',
    ].join(';');
    const render = () => {
      const muted = isMuted();
      btn.innerHTML = iconHtml(muted ? offLabel : onLabel);
      btn.style.opacity = muted ? '0.45' : '1';
    };
    btn.addEventListener('click', () => { onToggle(); render(); });
    render();
    return btn;
  };

  bar.appendChild(makeBtn('{music}', '{music_off}', 'Muzyka', () => audioManager.musicMuted,
    () => audioManager.setMusicMuted(!audioManager.musicMuted)));
  bar.appendChild(makeBtn('{sound}', '{sound_off}', 'Dźwięki', () => audioManager.sfxMuted,
    () => audioManager.setSfxMuted(!audioManager.sfxMuted)));

  if (onSettings) {
    const gear = makeBtn('{gear}', '{gear}', 'Ustawienia', () => false, onSettings);
    const sync = () => { gear.style.display = window.__myId ? '' : 'none'; };
    sync();
    setInterval(sync, 500);
    bar.appendChild(gear);
  }

  // Phaser hears a mouse release anywhere on the page: unshielded, a tap on these buttons also
  // "tapped" the backdrop under them, so muting closed the open Rynek and the gear reopened Ustawienia.
  // (AudioManager's wake listens in the capture phase, before this.)
  shieldFromPhaser(bar, { keys: false });
  parent.appendChild(bar);
  return bar;
}
